import type { Supplier } from '../types'

/** 12 fake suppliers aligned with Master Search connectors. */
export function createFakeSuppliers(): Supplier[] {
  const now = new Date().toISOString()
  const defs: Array<Omit<Supplier, 'id' | 'createdAt' | 'updatedAt' | 'searchCount'>> = [
    {
      name: 'Pauta',
      code: 'pauta',
      website: 'https://www.pauta.com.br',
      logo: null,
      supportsApi: true,
      supportsAutomation: true,
      supportsPix: true,
      supportsInstallments: true,
      active: true,
      kind: 'hybrid',
    },
    {
      name: 'Oderço',
      code: 'oderco',
      website: 'https://www.oderco.com.br',
      logo: null,
      supportsApi: true,
      supportsAutomation: false,
      supportsPix: true,
      supportsInstallments: true,
      active: true,
      kind: 'api',
    },
    {
      name: 'Agis',
      code: 'agis',
      website: 'https://www.agis.com.br',
      logo: null,
      supportsApi: true,
      supportsAutomation: true,
      supportsPix: true,
      supportsInstallments: true,
      active: true,
      kind: 'hybrid',
    },
    {
      name: 'All Nations',
      code: 'allnations',
      website: 'https://www.allnations.com.br',
      logo: null,
      supportsApi: true,
      supportsAutomation: false,
      supportsPix: true,
      supportsInstallments: true,
      active: true,
      kind: 'api',
    },
    {
      name: 'Ingram Micro',
      code: 'ingram',
      website: 'https://br.ingrammicro.com',
      logo: null,
      supportsApi: true,
      supportsAutomation: true,
      supportsPix: false,
      supportsInstallments: true,
      active: true,
      kind: 'hybrid',
    },
    {
      name: 'SND',
      code: 'snd',
      website: 'https://www.snd.com.br',
      logo: null,
      supportsApi: true,
      supportsAutomation: false,
      supportsPix: true,
      supportsInstallments: true,
      active: true,
      kind: 'api',
    },
    {
      name: 'KaBuM!',
      code: 'kabum',
      website: 'https://www.kabum.com.br',
      logo: null,
      supportsApi: false,
      supportsAutomation: true,
      supportsPix: true,
      supportsInstallments: true,
      active: true,
      kind: 'automation',
    },
    {
      name: 'Terabyte',
      code: 'terabyte',
      website: 'https://www.terabyteshop.com.br',
      logo: null,
      supportsApi: false,
      supportsAutomation: true,
      supportsPix: true,
      supportsInstallments: true,
      active: true,
      kind: 'automation',
    },
    {
      name: 'Pichau',
      code: 'pichau',
      website: 'https://www.pichau.com.br',
      logo: null,
      supportsApi: false,
      supportsAutomation: true,
      supportsPix: true,
      supportsInstallments: true,
      active: true,
      kind: 'automation',
    },
    {
      name: 'Amazon',
      code: 'amazon',
      website: 'https://www.amazon.com.br',
      logo: null,
      supportsApi: true,
      supportsAutomation: false,
      supportsPix: true,
      supportsInstallments: true,
      active: true,
      kind: 'api',
    },
    {
      name: 'Mercado Livre',
      code: 'mercadolivre',
      website: 'https://www.mercadolivre.com.br',
      logo: null,
      supportsApi: true,
      supportsAutomation: true,
      supportsPix: true,
      supportsInstallments: true,
      active: true,
      kind: 'hybrid',
    },
    {
      name: 'Magazine Luiza',
      code: 'magazineluiza',
      website: 'https://www.magazineluiza.com.br',
      logo: null,
      supportsApi: true,
      supportsAutomation: false,
      supportsPix: true,
      supportsInstallments: true,
      active: false,
      kind: 'api',
    },
  ]

  return defs.map((def, index) => ({
    ...def,
    id: `supplier-${index + 1}`,
    searchCount: (index + 1) * 7,
    createdAt: now,
    updatedAt: now,
  }))
}
